export default function getEndOfDayDate(date) {
  const clonedDate = new Date(date);
  clonedDate.setHours(23, 59, 59, 99);
  return clonedDate;
}
//# sourceMappingURL=getEndOfDayDate.js.map